import { Component, OnInit, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";
import { Routes, RouterModule } from "@angular/router";
import { FormControl } from "@angular/forms";
import { FilterPipe } from "../../../filter.pipe";
import { Observable } from "rxjs/Observable";
import { startWith } from "rxjs/operators/startWith";
import { AmChartsService, AmChart } from "@amcharts/amcharts3-angular";

import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { Http, Response } from "@angular/http";
import "rxjs/add/operator/map";

// import Fuse from 'fuse.js';

import pdfs from "./pdfs";

declare var Fuse: any;

const getCountryISO2 = require("country-iso-3-to-2");

export class Country {
  constructor(
    public countryName: string //  public overview: string, //   public id: number, //    public pi: string,
  ) {}
}

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent {
  private apiUrl = "http://sdg5.projects.theluminositylab.com/data/db.json";
  sifProjects: any = {};
  title: String;
  names: any;
  countries: any;
  dataTable: any;
  map: any;
  searchableList: any = ["countryName"];
  allDataFetched: boolean = false;
  public chart: AmChart;

  showPdf: boolean = false;
  pdfSrc: string = "";

  treeData: any;

  pageStart: number = 0;
  pageEnd: number = 100;
  pageHeight: number = 30;
  pageBuffer: number = 100;

  onScroll(event, doc) {
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    const offsetHeight = event.target.offsetHeight;
    const scrollPosition = scrollTop + offsetHeight;
    const scrollTreshold = scrollHeight - this.pageHeight;
    if (scrollPosition > scrollTreshold) {
      this.pageEnd += this.pageBuffer;
    }
  }

  // public options = {

  //   "type": "map",
  //   "theme": "none",
  //   "projection": "miller",
  //   "colorSteps": 50,
  //   "color": "#ECEFF5",
  //   "borderColor": "#ECEFF5",
  //   "borderAlpha": 1,
  //   "backgroundColor": "#ECEFF5",
  //   "backgroundAlpha": 1,
  //   "homeZoomLevel": 1,

  //   "dataProvider": {
  //     "map": "worldLow",
  //     "homeZoomLevel": 1,
  //     "areas": [ {
  //       "id": "US",
  //       "value": 75,
  //     }, {
  //       "id": "FR",
  //       "value": 32
  //     }],
  //   },
  // "areasSettings": {
  //   "autoZoom": true,
  //   "balloonText": "[[title]] <br> Score: [[value]]",
  //   "color": "#FF0000",
  //   "colorSolid": "#00FF00",
  //   "selectedColor":  "#003767",
  //   "rollOverOutlineColor": "#ECEFF5",
  //   "selectedOutlineColor":"#ECEFF5",
  //   "homeZoomLevel": 1,
  // },

  // "valueLegend": {
  //   "right": 10,
  //   "minValue": "Low Score",
  //   "maxValue": "High Score"
  // },

  // "export": {
  //   "enabled": false
  // },
  // }

  constructor(
    private router: Router,
    private http: Http,
    private AmCharts: AmChartsService
  ) {
    this.title = "Country Search";

    this.getProjects();
  }

  getData() {
    return this.http.get(this.apiUrl).map((res: Response) => res.json());
  }

  getProjects() {
    return this.getData().subscribe((data) => {
      this.map = data.map(function (country) {
        if (country["id"] === "ZAR") {
          country["id"] = "CD";
        } else if (country["id"] === "ROM") {
          country["id"] = "RO";
        } else {
          country["id"] = getCountryISO2(country["id"]);
        }

        country["customData"] = country["wblValue"];
        country["score"] = country["wblValue"];
        country["value"] = country["wblValue"];

        return country;
      });
      console.log("MAP:", this.map);
      this.countries = JSON.parse(JSON.stringify(this.map));
      this.runMap();
    });
  }

  documents(event) {
    this.router.navigate(["/", "docs", event]);
  }

  reporting(event) {
    this.router.navigate(["/", "reports", event]);
  }

  reportingPast(event) {
    this.router.navigate(["/", "reports-past", event]);
  }

  projects() {
    this.router.navigate(["/", "projects"]);
  }

  reports() {
    this.chart.zoomToGroup("US");
  }

  annual() {
    this.router.navigate(["/", "annual"]);
  }

  // docpage() {

  //   this.router.navigate(['/', 'docpage']);

  // }

  data(event) {
    this.router.navigate(["/", "data", event]);
  }

  setShowPdf(country: string) {
    const options = {
      keys: ["pdf"],
      threshold: 1.0,
    };

    // @ts-ignore
    const fuse = new Fuse(pdfs, options);

    const result = fuse.search(
      country === "United States of America" ? "united states" : country
    );

    this.showPdf = Boolean(result);
    this.pdfSrc = result[0].item.pdf;

    let override = null;

    if (country.includes("Bolivia")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Bolivia.pdf";
    } else if (country.includes("Congo") && country.includes("Democratic")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Congo-dem-rep.pdf";
    } else if (country.includes("El Salvador")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/El-salvador.pdf";
    } else if (country.includes("Côte")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Cote-divoire.pdf";
    } else if (country.includes("Czech")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Czech-republic.pdf";
    } else if (country.includes("Gabon")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Gabon.pdf";
    } else if (country.includes("Iran")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Iran-islamic-rep.pdf";
    } else if (country.includes("Ireland")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Ireland.pdf";
    } else if (country.includes("Jordan")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Jordan.pdf";
    } else if (country.includes("Republic of Korea")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Korea-rep.pdf";
    } else if (country.includes("Kyrgyzstan")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Kyrgyz-republic.pdf";
    } else if (country.startsWith("Lao")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Lao-pdr.pdf";
    } else if (country.includes("Lebanon")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Lebanon.pdf";
    } else if (country.includes("Libya")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Libya.pdf";
    } else if (country.includes("Moldova")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Moldova.pdf";
    } else if (country.includes("Morocco")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Morocco.pdf";
    } else if (country.includes("Slovakia")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Slovak-republic.pdf";
    } else if (country.includes("Sri Lanka")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Sri-lanka.pdf";
    } else if (country.includes("Tanzania")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Tanzania.pdf";
    } else if (country.includes("United Arab Emirates")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/United-arab-emirates.pdf";
    } else if (country.includes("United Kingdom")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/United-kingdom.pdf";
    } else if (country.includes("Venezuela")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Venezuela-rb.pdf";
    } else if (country.includes("Yemen")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Yemen-rep.pdf";
    } else if (country === "Central African Republic") {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Central-african-republic.pdf";
    } else if (country.includes("United States")) {
      override =
        "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/United-states.pdf";
    }

    console.log({
      country,
      override,
      result: result[0].item.pdf,
      pdfSrc: this.pdfSrc,
    });

    window.open(override || result[0].item.pdf, "_blank");
  }

  runMap() {
    setTimeout(() => {
      const thisObj = this;
      this.chart = this.AmCharts.makeChart("chartdiv", {
        type: "map",
        theme: "light",
        projection: "miller",
        color: "#ffffff",
        maxValue: 95,
        minValue: 30,
        borderColor: "#ffffff",
        borderAlpha: 1,
        backgroundColor: "#ffffff",
        backgroundAlpha: 1,
        homeZoomLevel: 1,
        colorSteps: 7,

        dataProvider: {
          map: "worldLow",

          homeZoomLevel: 1,
          areas: this.map,
        },
        areasSettings: {
          autoZoom: true,
          balloonText: "[[title]] <br> WBL Score: [[customData]] ", // "[[title]] <br> Score: [[value]] <br> WBL Score: [[customData]] ",
          color: "#99E7FF",
          colorSolid: "#004E66",
          alpha: 0.9,
          selectedColor: undefined,
          rollOverOutlineColor: "#ECEFF5",
          selectedOutlineColor: "#ECEFF5",
          homeZoomLevel: 1,
        },

        // "valueLegend": {
        //   "right": 20,
        //   "bottom": 20,
        //   "maxValue": "100",
        //   "minValue": "30",
        // },

        export: {
          enabled: false,
        },
        listeners: [
          {
            event: "clickMapObject",
            method: function (ev) {
              console.log({ obj: ev.mapObject });
              thisObj.setShowPdf(ev.mapObject.countryName);
            },
          },
        ],
      });
    }, 3000);
    this.allDataFetched = true;
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/home/home/home.component.ts